import { useShop } from '../context/ShopContext';
import { formatRole, storefrontUrlForShop } from '../utils/format';

function ExternalLinkIcon() {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
      <polyline points="15 3 21 3 21 9" />
      <line x1="10" y1="14" x2="21" y2="3" />
    </svg>
  );
}

export function SidebarStorefront() {
  const { shops, selectedShop, selectedShopId, setSelectedShopId } = useShop();

  if (!selectedShop) {
    return null;
  }

  const { shop } = selectedShop;
  const storefrontUrl = storefrontUrlForShop(shop);

  return (
    <div className="sidebar-storefront">
      <div className="sidebar-storefront-row">
        {shops.length > 1 ? (
          <select
            id="sidebar-shop-select"
            className="sidebar-store-select"
            value={selectedShopId ?? ''}
            onChange={(event) => setSelectedShopId(Number(event.target.value))}
            aria-label="Select store"
          >
            {shops.map((entry) => (
              <option key={entry.shop.id} value={entry.shop.id}>
                {entry.shop.name}
              </option>
            ))}
          </select>
        ) : (
          <span className="sidebar-store-name" title={shop.name}>
            {shop.name}
          </span>
        )}

        {storefrontUrl && (
          <a
            href={storefrontUrl}
            className="sidebar-storefront-btn"
            target="_blank"
            rel="noopener noreferrer"
            title="View storefront"
            aria-label="View storefront"
          >
            <ExternalLinkIcon />
          </a>
        )}
      </div>
      <span className="sidebar-store-role">{formatRole(selectedShop.role)}</span>
    </div>
  );
}

export function ShopTopBar() {
  const { selectedShop } = useShop();

  if (!selectedShop) {
    return null;
  }

  const storefrontUrl = storefrontUrlForShop(selectedShop.shop);
  if (!storefrontUrl) {
    return null;
  }

  return (
    <div className="shop-top-bar">
      <span className="shop-top-bar-label">{selectedShop.shop.name}</span>
      <a
        href={storefrontUrl}
        className="shop-top-bar-link"
        target="_blank"
        rel="noopener noreferrer"
      >
        View storefront
        <ExternalLinkIcon />
      </a>
    </div>
  );
}
